module.exports = __webpack_public_path__ + "img/theme.b1afbd50.svg";